<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">event_repeat</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Editar parcela</h2>
    <p class="modal-subtitle">Pagamento</p>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
      (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="vpd-conteudo" [formGroup]="copia">
  <!-- Um campo por linha, em section-container sem borda (§8.7.1). -->
  <div class="vpd-campo">
    <span class="vpd-rotulo">Parcela</span>
    <span class="vpd-leitura">{{ titulo }}</span>
  </div>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Data de vencimento</mat-label>
    <input matInput formControlName="dataVencimento" [matDatepicker]="dpVencimento" placeholder="DD/MM/AAAA"
      (input)="onDateInput($event, copia.get('dataVencimento'))" [readonly]="data.isSomenteLeitura">
    <mat-datepicker-toggle matSuffix [for]="dpVencimento" [disabled]="data.isSomenteLeitura"></mat-datepicker-toggle>
    <mat-datepicker #dpVencimento></mat-datepicker>
    <!-- Alterar o vencimento recalcula os Dias a partir da emissão (§8.7.1). -->
    <mat-hint>{{ copia.get('dias')?.value != null ? copia.get('dias')?.value + ' dias após a emissão' : '' }}</mat-hint>
    @if (copia.get('dataVencimento')?.hasError('required') && copia.get('dataVencimento')?.touched) {
      <mat-error>Informe o vencimento.</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Valor</mat-label>
    <input matInput formControlName="valor" [currencyMask]="data.mascaraDinheiro" class="vpd-num"
      [readonly]="data.isSomenteLeitura">
    @if (copia.get('valor')?.invalid && copia.get('valor')?.touched) {
      <mat-error>Informe um valor maior que zero.</mat-error>
    }
  </mat-form-field>

  <!-- NSU não existe no orçamento: ele não concilia financeiro (§8.7.1). -->
  @if (!data.ehOrcamento) {
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>NSU</mat-label>
      <input matInput formControlName="nsu" [readonly]="data.isSomenteLeitura" [required]="data.isNsuObrigatorio === true">
      <mat-hint>Identificador da transação para conciliação no financeiro.</mat-hint>
      @if (copia.get('nsu')?.hasError('required') && copia.get('nsu')?.touched) {
        <mat-error>O contas a receber exige o NSU da parcela.</mat-error>
      }
    </mat-form-field>
  }

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Observação</mat-label>
    <textarea matInput formControlName="observacao" rows="3" [maxlength]="observacaoMaximo"
      [readonly]="data.isSomenteLeitura" [required]="data.isObservacaoObrigatoria === true"></textarea>
    <mat-hint>Aparece na parcela e acompanha o título gerado no financeiro.</mat-hint>
    @if (copia.get('observacao')?.hasError('required') && copia.get('observacao')?.touched) {
      <mat-error>O contas a receber exige a observação da parcela.</mat-error>
    }
    <mat-hint align="end">{{ observacaoTamanho }}/{{ observacaoMaximo }}</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="vpd-rodape">
  <button type="button" mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  @if (!data.isSomenteLeitura) {
    <button type="button" mat-flat-button class="btn-primary" (click)="salvar()">Salvar</button>
  }
</mat-dialog-actions>
